import type { ReactNode } from 'react';
import { TypographyText } from '@/components/base/Typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';

export { Button } from '@/components/ui/button';

interface ButtonProps {
  className?: string;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link' | null;
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export const PrimaryButtonLarge = ({ className, variant, children, ...props }: ButtonProps) => (
  <TypographyText>
    <Button
      className={cn('rounded-full p-6 text-lg font-normal text-white', className)}
      variant={variant || 'default'}
      {...props}
    >
      {children}
    </Button>
  </TypographyText>
);
PrimaryButtonLarge.displayName = 'PrimaryButtonLarge';

export const PrimaryButtonMedium = ({ className, variant, children, ...props }: ButtonProps) => (
  <Button className={cn('h-10 rounded-full', className)} variant={variant || 'default'} {...props}>
    {children}
  </Button>
);
PrimaryButtonMedium.displayName = 'PrimaryButtonMedium';

export const PrimaryButtonSmall = ({ className, ...rest }: ButtonProps) => {
  return <Button className={cn('rounded-full text-sm text-white', className)} {...rest} />;
};

export const SecondaryButtonLarge = ({ className, ...rest }: ButtonProps) => {
  return (
    <Button
      className={cn('rounded-md p-6 text-lg font-normal tracking-wide', className)}
      variant="secondary"
      {...rest}
    />
  );
};

export const SecondaryButtonMedium = ({ className, ...rest }: ButtonProps) => {
  return (
    <Button
      className={cn('text-md rounded-full px-6 py-4 font-normal tracking-wide', className)}
      {...rest}
    />
  );
};

export const AuthButtonLarge = ({ disabled, onClick, className, ...rest }: ButtonProps) => {
  if (disabled) {
    return (
      <PrimaryButtonLarge
        className={cn('rounded-md bg-slate-300 text-white', className)}
        {...rest}
      />
    );
  }

  return <PrimaryButtonLarge className={cn('rounded-md', className)} onClick={onClick} {...rest} />;
};

export const AuthButtonMedium = ({ disabled, onClick, className, ...rest }: ButtonProps) => {
  if (disabled) {
    return <PrimaryButtonMedium className={cn('bg-slate-300 text-white', className)} {...rest} />;
  }

  return <PrimaryButtonMedium className={cn(className)} onClick={onClick} {...rest} />;
};
